var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMerchOpenIcon = function SvgMerchOpenIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "main-color-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 12
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.738 12.357 12.838 0c-3.107.03-9.3.072-12.4.1L.412 1.647c2.795-.027 6.5-.05 9.769-.08L-.002 11.71l1.086 1.082L11.267 2.649l-.088 9.722 1.561-.017Z"
  })));
};
export default SvgMerchOpenIcon;